import type { TableHeader } from "@/shared/components/temparary/components/base/table/TableModel";

import type { StudentStatus } from "@/widgets/search-students/models/interface";

/** student-search */
export const STUDENT_SEARCH_TABLE_HEADER: TableHeader[] = [
    {
        id: "1",
        title: "상태",
        indexValue: "status",
        align: "center",
        width: "10rem",
    },
    {
        id: "2",
        title: "학생명",
        indexValue: "name",
        align: "center",
    },
    {
        id: "3",
        title: "휴대전화번호",
        indexValue: "phone",
        align: "center",
        width: "30rem",
    },
    {
        id: "4",
        title: "학교명",
        indexValue: "school",
        align: "center",
        width: "30rem",
    },
    {
        id: "5",
        title: "학년",
        indexValue: "grade",
        align: "center",
        width: "16rem",
    },
];

export const STUDENT_SEARCH_STATUS_LIST: {
    index: StudentStatus;
    value: string;
    totalCount: number | null;
}[] = [
    {
        index: "academyStudent",
        value: "재원생",
        totalCount: null,
    },
    {
        index: "candidateStudent",
        value: "비재원생",
        totalCount: null,
    },
    {
        index: "formerStudent",
        value: "퇴원생",
        totalCount: null,
    },
];
